import { render, staticRenderFns } from "./OnDemandLandingPage.vue?vue&type=template&id=30441b77&"
import script from "./OnDemandLandingPage.vue?vue&type=script&lang=js&"
export * from "./OnDemandLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports